const TEN_MINUTES = 10 * 60 * 1000;

/**
 * Checks whether the server serves another build than the one running (R56): reads /version.json every ten minutes and when the window gets focus, and calls
 * onChange once when its version or buildId differs from current's. It then stops. A failed fetch (offline, a response that is not ok, a non-JSON answer, an answer without a string version and buildId) is ignored and the next
 * check tries again. Returns stop, which clears the interval and the focus listener.
 */
export function startVersionCheck({
    current,
    fetchJson = url => fetch(url, {cache: 'no-store'}).then(r => {
        if (!r.ok) throw new Error(`version.json answered ${r.status}`);
        return r.json();
    }),
    intervalMs = TEN_MINUTES,
    onChange,
    setInterval = window.setInterval.bind(window),
    clearInterval = window.clearInterval.bind(window),
    addFocusListener = fn => window.addEventListener('focus', fn),
    removeFocusListener = fn => window.removeEventListener('focus', fn),
}) {
    let stopped = false;
    let timer = null;

    const stop = () => {
        if (stopped) return;
        stopped = true;
        clearInterval(timer);
        removeFocusListener(check);
    };

    function check() {
        if (stopped) return;
        let request;
        try {
            request = Promise.resolve(fetchJson(`/version.json?t=${Date.now()}`));
        } catch (e) {
            return;
        }
        request.then(remote => {
            if (stopped || !remote || typeof remote.version !== 'string' || typeof remote.buildId !== 'string') return;
            if (remote.version !== current.version || remote.buildId !== current.buildId) {
                stop();
                onChange();
            }
        }, () => {});
    }

    timer = setInterval(check, intervalMs);
    addFocusListener(check);
    return stop;
}
